import {setAreaCoverage} from '@explorer/actions/area-coverage';
import {setMode, showLeftDrawer, showRightDrawer} from '@explorer/actions/ui';

export const buildUiActions = storedState => {
  const actions = [];
  if (storedState.ui) {
    if (storedState.ui.mode) {
      actions.push(setMode(storedState.ui.mode));
    }
    if (storedState.areaCoverage) {
      actions.push(setAreaCoverage(storedState.areaCoverage));
    }
    if (storedState.ui.drawers && storedState.ui.drawers.left) {
      actions.push(showLeftDrawer(storedState.ui.drawers.left));
    }
    if (storedState.ui.drawers && storedState.ui.drawers.right) {
      actions.push(showRightDrawer(storedState.ui.drawers.right));
    }
  }
  return actions;
};
